var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { ref: "main", staticStyle: { position: "relative" } },
    [
      !_vm.maxDisplay || _vm.focused || !_vm.optionsFake.length
        ? _c("v-select", {
            ref: "select",
            style:
              "position:absolute;width:" +
              (_vm.clearText && _vm.optionsChoisies.length
                ? "calc(100% - 40px);"
                : "100%;"),
            attrs: {
              multiple: _vm.multiple,
              "append-to-body": !!_vm.dropdownPosition,
              "calculate-position": _vm.calcPosition,
              disabled: _vm.disabled,
              clearable: true,
              value: _vm.optionsChoisies,
              options: _vm.optionsDisponibles,
              placeholder: _vm.placeholder,
              closeOnSelect: !_vm.multiple
            },
            on: {
              input: _vm.handleInput,
              "search:focus": _vm.handleFocus,
              "search:blur": _vm.handleBlur,
              search: _vm.handleSearch
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "no-options",
                  fn: function() {
                    return [_vm._v(" " + _vm._s(_vm.texteVide) + " ")]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              610198314
            )
          })
        : _c(
            "div",
            [
              _c("v-select", {
                style:
                  "position:absolute;width:" +
                  (_vm.clearText && _vm.optionsChoisies.length
                    ? "calc(100% - 40px);"
                    : "100%;"),
                attrs: {
                  multiple: _vm.multiple,
                  "append-to-body": !!_vm.dropdownPosition,
                  "calculate-position": _vm.calcPosition,
                  disabled: _vm.disabled,
                  clearable: true,
                  value: _vm.optionsFake,
                  options: _vm.optionsDisponibles,
                  placeholder: _vm.placeholder,
                  closeOnSelect: !_vm.multiple
                },
                on: {
                  input: _vm.handleFocus2,
                  "search:focus": _vm.handleFocus2
                },
                scopedSlots: _vm._u([
                  {
                    key: "no-options",
                    fn: function() {
                      return [_vm._v(" " + _vm._s(_vm.texteVide) + " ")]
                    },
                    proxy: true
                  }
                ])
              }),
              _c(
                "span",
                {
                  staticStyle: {
                    position: "absolute",
                    right: "44px",
                    bottom: "-3px",
                    "font-weight": "bold",
                    color: "gray",
                    "font-size": "25px"
                  },
                  on: { click: _vm.handleFocus2 }
                },
                [_vm._v("...")]
              )
            ],
            1
          ),
      _vm.clearText && _vm.optionsChoisies.length
        ? _c(
            "b-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: { content: _vm.clearText, placement: "top" },
                  expression: "{ content: clearText, placement: 'top' }"
                }
              ],
              staticClass: "btn btn-secondary",
              staticStyle: {
                width: "35px",
                height: "35px",
                margin: "3px 5px",
                flex: "0 0 35px",
                position: "absolute",
                right: "-10px",
                top: "0"
              },
              on: { click: _vm.handleClear }
            },
            [_c("i", { staticClass: "fas fa-times" })]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }